import React from 'react'

import { Box, CircularProgress, Typography } from '@mui/material'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { useAppStore } from '../store/useAppStore'
import { useTranslation } from 'react-i18next'
import { QueryKey } from '../constants'

export default function FullPageLoading() {
  const isCustomLoading = useAppStore((state) => state.loading)
  const isSendingData = useIsMutating()
  // Exclude image blob queries from the loading state
  // We don't need to show loading state for image fetching
  const queryFilters = Object.values(QueryKey).filter(
    (key) => key !== QueryKey.ImageBlob
  )
  const isFetchingData = useIsFetching(queryFilters)
  const { t } = useTranslation()

  const isVisible = isSendingData || isFetchingData || isCustomLoading

  const defaultLoading = (isFetchingData || isCustomLoading) && !isSendingData

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 1305,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: isVisible ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, .6)',
      }}
    >
      {!!isSendingData && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
          <Typography variant="body2" sx={{ marginTop: 2 }}>
            {t('loading.processing')}...
          </Typography>
        </Box>
      )}
      {!!defaultLoading && <CircularProgress />}
    </Box>
  )
}
